import { render, staticRenderFns } from "./index.vue?vue&type=template&id=686477b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=686477b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686477b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686477b6')) {
      api.createRecord('686477b6', component.options)
    } else {
      api.reload('686477b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=686477b6&scoped=true", function () {
      api.rerender('686477b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overseasInventory/uploadPrice/index.vue"
export default component.exports